import { Link } from 'react-router-dom';
import OwnerManager from './OwnerManager';
import AddOwnerManager from './AddOwnerManager';
import { resetAccountCall } from '../Redux/AccountSettings/AccountSettingsActions';
import React, {useEffect} from 'react';
import { useDispatch } from 'react-redux';

function OwnerManagerMaster() {
    
    const dispatch = useDispatch();
  
    useEffect(() =>{
      dispatch(resetAccountCall());
    },[dispatch])
    
    
        return (           
          <>
          <div className="breadcrumbs-area">
            <h3>Owner And Manager Name</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Owner And Manager Name</li>
            </ul>
          </div>
            {/* Breadcubs Area Start Here */}
            <div className="row dashboard-card-six">
                {/* <OwnerManager /> */}
                <AddOwnerManager />

            </div>
          </>       
        );
}

export default OwnerManagerMaster;
